import type { Icon } from '../../../src/lib/types'
export const mdiFormatHorizontalAlignRight: Icon = {
  "id": "format-horizontal-align-right",
  "name": "Format Horizontal Align Right",
  "path": "M13,8V11H3V13H13V16L17,12L13,8M19,20H21V4H19V20Z",
  "as": [],
  "tags": [
    "Text / Content / Format"
  ]
}
export default mdiFormatHorizontalAlignRight